import React, { useState } from 'react';
import MobileNav from './MobileNav/MobileNav';
import { services } from '../SeoRoutes/SeoRoutes';
import categories from '../../data/categories.json';

const Header = () => {
    // Hide header on scroll down
    window.onscroll = function () { myFunction() }; 
    function myFunction() {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            document.querySelector('header').classList.add('dark_mode');
            document.querySelector('header .top_bar').classList.add('top-up');
        } else {
            document.querySelector('header').classList.remove('dark_mode');
            document.querySelector('header .top_bar').classList.remove('top-up');
        }
    }

    const [isActive, setActive] = useState("false");
    const handleToggle = () => {
        setActive(!isActive);
    };

    return (
        <>
            <header className="header">
                {/* <PreHeader /> */}

                <div className="top_bar" id='top-bar' style={{borderRadius: '0 0 20px 20px', background: 'var(--red-color)'}}>
                    <div className="container">
                       
                    </div>
                </div>

                <div className="middle_bar" style={{ background: 'white' }}>
                    <div className="container">
                        <div className="middle_bar_inner">
                            <div className="logo" style={{ width: '100px' }}>
                                <a href="/" className="light_mode_logo">
                                    <img src="images/logo.png" alt="logo" />
                                </a>
                                <a href="/" className="dark_mode_logo">
                                    <img src="images/logo.png" alt="logo" />
                                </a>
                            </div>

                            <div className="header_right_part">
                                <div className="mainnav">
                                    <ul className="main_menu">
                                        <li className="menu-item">
                                            <a href="/">Home</a>
                                        </li>
                                        <li className="menu-item">
                                            <a href="/chi-siamo">Chi Siamo</a>
                                        </li>
                                        {/* Menu Costruzioni */}
                                        <li className="menu-item menu-item-has-children">
                                            <a href="#">Costruzioni</a>
                                            <ul className="sub-menu">
                                                {Object.entries(categories)
                                                    .filter(([key]) => ['costruzione-chiavi-in-mano', 'ristrutturazione', 'miglioramento-energetico', 'coperture', 'sistemazione-esterni'].includes(key))
                                                    .map(([key, value]) => (
                                                        <li key={key} className="menu-item">
                                                            <a href={`/${key}`}>{value}</a>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </li>
                                        {/* Menu Servizi */}
                                        <li className="menu-item menu-item-has-children">
                                            <a href="#">Servizi</a>
                                            <ul className="sub-menu">
                                                {Object.entries(categories)
                                                    .filter(([key]) => ['servizi-fognature', 'movimenti-di-terra', 'piccoli-impianti-civili', 'pavimenti-rivestimenti', 'pitture'].includes(key))
                                                    .map(([key, value]) => (
                                                        <li key={key} className="menu-item">
                                                            <a href={`/${key}`}>{value}</a>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </li>
                                        <li className="menu-item">
                                            <a href="/contatti">Contatti</a>
                                        </li>
                                    </ul>
                                </div>
                                
                                <div className='header_search' onClick={handleToggle}>
                                    <button type="submit" className="form-control-submit">
                                        <i className="ion-ios-search"></i>
                                    </button>
                                </div>

                                <button 
                                    className="ma5menu__toggle position-relative d-lg-none" 
                                    type="button" 
                                    data-bs-toggle="offcanvas" 
                                    data-bs-target="#offcanvasHome" 
                                    aria-controls="offcanvasHome"
                                >
                                    <i className="ion-android-menu"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <MobileNav />

        </>
    );
};

export default Header;